var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterSectionGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#74788D",
    d: "M0.5 0.5H15.5V17.25H0.5z",
    transform: "translate(-1294 -480) translate(1294 480.854)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#51A6F1",
    d: "M5 5.146H11V12.146H5z",
    transform: "translate(-1294 -480) translate(1294 480.854)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSectionGroup);
export default __webpack_public_path__ + "static/media/filter-section-group.cb5ce7cdd13f20f7755955a822101189.svg";
export { ForwardRef as ReactComponent };